"use client";

import { useState } from "react";

type Status = "idle" | "sending" | "ok" | "error";

export function FooterFeedbackForm() {
  const [status, setStatus] = useState<Status>("idle");
  const [error, setError] = useState<string | null>(null);

  async function onSubmit(event: React.FormEvent<HTMLFormElement>) {
    event.preventDefault();
    const form = event.currentTarget;
    const data = new FormData(form);

    setStatus("sending");
    setError(null);

    try {
      const response = await fetch("/api/feedback", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          name: String(data.get("name") ?? ""),
          contact: String(data.get("contact") ?? ""),
          message: String(data.get("message") ?? ""),
          consent: data.get("consent") === "on",
          company: String(data.get("company") ?? ""),
          page: typeof window !== "undefined" ? window.location.pathname : "",
        }),
      });

      const payload = (await response.json().catch(() => ({}))) as { error?: string };

      if (!response.ok) {
        setStatus("error");
        setError(payload.error ?? "Не удалось отправить. Попробуйте ещё раз.");
        return;
      }

      form.reset();
      setStatus("ok");
    } catch {
      setStatus("error");
      setError("Сеть недоступна. Попробуйте позже.");
    }
  }

  return (
    <form className="feedback-form" onSubmit={onSubmit} noValidate>
      <div className="feedback-form__row">
        <label className="feedback-form__field">
          <span>Имя</span>
          <input name="name" type="text" autoComplete="name" placeholder="Как к вам обращаться" />
        </label>
        <label className="feedback-form__field">
          <span>Email или телефон</span>
          <input
            name="contact"
            type="text"
            required
            autoComplete="email"
            placeholder="you@example.com"
          />
        </label>
      </div>

      <label className="feedback-form__field">
        <span>Сообщение</span>
        <textarea name="message" required rows={3} placeholder="Опишите вопрос или идею" />
      </label>

      {/* honeypot: скрытое поле от ботов */}
      <label className="feedback-form__hp" aria-hidden="true">
        <span>Не заполняйте</span>
        <input name="company" type="text" tabIndex={-1} autoComplete="off" />
      </label>

      <label className="feedback-form__consent">
        <input name="consent" type="checkbox" required />
        <span>
          Согласен(на) на обработку персональных данных —{" "}
          <a href="/personal-data-consent" target="_blank" rel="noreferrer">
            согласие
          </a>{" "}
          и{" "}
          <a href="/privacy" target="_blank" rel="noreferrer">
            политика
          </a>
          .
        </span>
      </label>

      {status === "ok" && (
        <p className="feedback-form__status feedback-form__status--ok" role="status">
          Спасибо! Сообщение отправлено — ответим на указанный контакт.
        </p>
      )}
      {status === "error" && error && (
        <p className="feedback-form__status feedback-form__status--error" role="alert">
          {error}
        </p>
      )}

      <div className="feedback-form__actions">
        <button type="submit" className="btn btn--primary" disabled={status === "sending"}>
          {status === "sending" ? "Отправляем…" : "Отправить"}
        </button>
        <span className="feedback-form__hint">
          Или напишите на{" "}
          <a href="mailto:support@slotislot.ru">support@slotislot.ru</a>
        </span>
      </div>
    </form>
  );
}
